"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onSuccess = exports.onFailure = exports.hasSameValues = exports.getReading = exports.getIndex = void 0;

var _luxon = require("luxon");

var hasSameValues = function hasSameValues(reading, prospectId, luxonStart, luxonEnd) {
  var luxonReadingStart = _luxon.DateTime.fromISO(reading.startDate);

  var luxonReadingEnd = _luxon.DateTime.fromISO(reading.endDate);

  return reading.prospectId.toString() === prospectId.toString() && luxonReadingStart.hasSame(luxonStart, 'minute') && luxonReadingEnd.hasSame(luxonEnd, 'minute');
};

exports.hasSameValues = hasSameValues;

var getValues = function getValues(arr, prospectId, startDate, endDate) {
  var luxonStart = _luxon.DateTime.fromISO(startDate, {
    setZone: true
  });

  var luxonEnd = _luxon.DateTime.fromISO(endDate, {
    setZone: true
  });

  return arr.filter(function (reading) {
    return hasSameValues(reading, prospectId, luxonStart, luxonEnd);
  });
};

var getIndex = function getIndex(arr, prospectId, startDate, endDate) {
  var luxonStart = _luxon.DateTime.fromISO(startDate, {
    setZone: true
  });

  var luxonEnd = _luxon.DateTime.fromISO(endDate, {
    setZone: true
  });

  return arr.findIndex(function (reading) {
    return hasSameValues(reading, prospectId, luxonStart, luxonEnd);
  });
};

exports.getIndex = getIndex;

var getReading = function getReading(prospectId, startDate, endDate, store, dataProp) {
  var values = getValues(store.get(dataProp), prospectId, startDate, endDate);

  if (values.size > 0) {
    return values.first().data || values.first();
  }

  return null;
};

exports.getReading = getReading;

var onSuccess = function onSuccess(action, state, valuesProp) {
  var loadingProp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'loading';
  var errorProp = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'error';
  var _action$payload = action.payload,
      prospectId = _action$payload.prospectId,
      startDate = _action$payload.startDate,
      endDate = _action$payload.endDate;
  var index = getIndex(state.get(loadingProp), prospectId, startDate, endDate);
  var newState = state.set(errorProp, null).updateIn([valuesProp], function (arr) {
    return arr.push(action.payload);
  });

  if (index > -1) {
    return newState.deleteIn([loadingProp, index]);
  }

  return newState;
};

exports.onSuccess = onSuccess;

var onFailure = function onFailure(action, state) {
  var loadingProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'loading';
  var errorProp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'error';
  var _action$payload2 = action.payload,
      prospectId = _action$payload2.prospectId,
      startDate = _action$payload2.startDate,
      endDate = _action$payload2.endDate,
      error = _action$payload2.error;
  var index = getIndex(state.get(loadingProp), prospectId, startDate, endDate);
  var newState = state.set(errorProp, error);

  if (index > -1) {
    return newState.deleteIn([loadingProp, index]);
  }

  return newState;
};

exports.onFailure = onFailure;